import { Component, ElementRef, inject, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { AppMenuitemComponent } from './app-menuitem.component';

@Component({
    selector: 'app-menu',
    standalone: true,
    imports: [CommonModule, AppMenuitemComponent, RouterModule],
    template: `
        <ul class="layout-menu" #menuContainer>
            <ng-container *ngFor="let item of model; let i = index">
                <li app-menuitem *ngIf="!item.separator" [item]="item" [index]="i" [root]="true"></li>
                <li *ngIf="item.separator" class="menu-separator relative"></li>
            </ng-container>
        </ul>
    `
})
export class AppMenuComponent {
    el = inject(ElementRef);

    @ViewChild('menuContainer') menuContainer!: ElementRef;

    model: any[] = [
        {
            label: 'Favorites',
            icon: 'pi pi-home',
            items: [
                {
                    label: 'Users',
                    icon: 'fa-solid fa-users',
                    acl: { scope: 'all', acl: ['read:users'] },
                    routerLink: ['/users']
                },
                {
                    label: 'Wallet',
                    icon: 'fa-solid fa-store',
                    acl: { scope: 'all', acl: ['read:wallet'] },
                    routerLink: ['/wallet']
                },
                {
                    label: 'Manual Balance',
                    icon: 'pi pi-dollar',
                    acl: { scope: 'all', acl: ['read:authority-logs'] },
                    routerLink: ['/authority-logs']
                },
                {
                    label: 'Payments Search',
                    icon: 'pi pi-search',
                    acl: { scope: 'all', acl: ['read:users'] },
                    routerLink: ['/payments-search']
                },
                // {
                //     label: 'Linked Games',
                //     icon: 'pi pi-link',
                //     acl: { scope: 'all', acl: ['read:platform-games-deposit-histories'] },
                //     routerLink: ['/platform-games-deposit-histories']
                // },
                {
                    label: 'Games Settings',
                    icon: 'pi pi-play',
                    acl: { scope: 'all', acl: ['read:globals-games-settings'] },
                    routerLink: ['/games-settings']
                },
                {
                    label: 'Tournaments',
                    icon: 'pi pi-play-circle',
                    acl: { scope: 'all', acl: ['read:globals-tournament-type-settings'] },
                    routerLink: ['/tournaments']
                },
                {
                    label: 'History',
                    icon: 'pi pi-history',
                    acl: { scope: 'all', acl: ['read:tournaments'] },
                    routerLink: ['/histories']
                },
                {
                    label: 'Universal Payment Account',
                    icon: 'pi pi-credit-card',
                    acl: { scope: 'all', acl: ['read:payments'] },
                    routerLink: ['/universal-payment-account']
                },
                {
                    label: 'Chat',
                    icon: 'fa-solid fa-users',
                    acl: { scope: 'all', acl: ['read:platform-chat-messages'] },
                    routerLink: ['/chat'],
                    badge: true
                },
                {
                    label: 'Referral Code',
                    icon: 'fa-solid fa-code',
                    acl: { scope: 'all', acl: ['read:referral-codes'] },
                    routerLink: ['/referral-code'],
                    badge: true
                },
                {
                    label: 'Banned States',
                    icon: 'fa-solid fa-ban',
                    acl: { scope: 'all', acl: ['read:states'] },
                    routerLink: ['/states'],
                    badge: true
                }
            ]
        },
        {
            label: 'System',
            icon: 'fa-solid fa-gear',
            acl: {
                scope: 'any',
                acl: ['read:authorities', 'read:roles']
            },
            items: [
                {
                    label: 'Security',
                    icon: 'fa-solid fa-lock',
                    acl: {
                        scope: 'all',
                        acl: ['read:authorities', 'read:roles', 'read:provider-users']
                    },
                    routerLink: ['/security'],
                    items: [
                        {
                            label: 'Authorities',
                            icon: 'fa-solid fa-user-shield',
                            acl: {
                                scope: 'all',
                                acl: ['read:authorities', 'read:roles', 'read:provider-users']
                            },
                            routerLink: ['/security/authorities']
                        },
                        {
                            label: 'Roles',
                            icon: 'fa-solid fa-shield',
                            acl: { scope: 'all', acl: ['read:roles'] },
                            routerLink: ['/security/roles']
                        }
                    ]
                }
            ]
        }
    ];
}
